import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import { connect } from "react-redux";
import {
  AccordionDetails,
  AccordionSummary,
  Alert,
  Avatar,
  Box,
  Button,
  CardActionArea,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  Typography,
} from "@mui/material";
import { ChangeCircle, DeleteOutline, EditOutlined, PersonAddAlt1Outlined } from "@mui/icons-material";
import FormDialog from "../../helpers/FormDialog";
import React, { useEffect, useState } from "react";
import moment from "moment";
import DeleteDialog from "../../helpers/DeleteDialog";
import ProjectDndProvider from "./ProjectDndProvider";
import { HTML5Backend } from "react-dnd-html5-backend";
import { DndProvider } from "react-dnd";
import StyledBadge from "../../helpers/StyledBadge";
import { grey } from "@mui/material/colors";
import { downloadUrl } from "../../Shared/commonFunction";
import { errorToast, successToast } from "../../helpers/Notification";
import {
  currencyValues,
  getError,
  getSuccessMessage,
} from "../../store/helpers/common_functions";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import { getQuery } from "../../helpers/Common_functions";
import WorklogManager from "../../views/admin/WorklogManager";
import StatusLayout from "components/Status";
import DatatableComponent from "helpers/DatatableComponent";
import QtMaterialButton from "components/QtMaterialButton";
import axios from "axios";

function ProjectActivities({
  info,
  projectId,
  PutAction,
  loggedUser,
  FetchDetails,
  canEdit,
  funders,
  partners,
  SubmitGeneralForm,
  onLoad,
  systemSettings,
}) {
  const mainBackground = systemSettings?.mainBackground;

  const { deliverables, project, totalAllocatedBudget } = info;

  const activeIndex = deliverables?.findIndex(
    (v) => v.status === "in-progress"
  );

  let defaultAccordion = null;
  if (activeIndex > -1) {
    defaultAccordion = `panel${activeIndex}`;
  } else if (deliverables?.length) {
    defaultAccordion = `panel${deliverables?.length - 1}`;
  }

  const [open, setOpen] = React.useState(0);
  const [value, setValue] = React.useState({});
  const [id, setId] = React.useState();
  const [success, setSuccess] = React.useState(0);
  const [maxBudget, setMaxBudget] = React.useState(0);
  const [deleteOpen, setDeleteOpen] = React.useState(false);
  const [assignOpen, setAssignOpen] = React.useState(false);
  const [mergeOpen, setMergeOpen] = React.useState(false);
  const [logOpen, setLogOpen] = React.useState(false);
  const [selectedDev, setSelectedDev] = React.useState([]);
  const [assigning, setAssigning] = React.useState(false);
  const [deliverable, setDeliverable] = React.useState(false);
  const [paid, setPaid] = React.useState(false);
  const [progress, setProgress] = React.useState(false);
  const [status, setStatus] = React.useState(null);
  const [mergerIntoId, setMergeIntoId] = React.useState(null);
  const [activities, setActivities] = React.useState([]);
  const [addFunder, setAddFunder] = useState(0);
  const [activity, setActivity] = useState([]);
  const [count, setCount] = useState(0);
  const [partnersOpen, setPartnersOpen] = useState(false);
  const [fetchedPartners, setPartners] = useState([]);
  const [addPartner, setAddPartner] = useState(0);
  const [isLoadingPartners, setIsLoadingPartners] = useState(false);
  const [partnerId, setPartnerId] = useState(null);
  const [tabValue, setTabValue] = React.useState(0);
  const [installments, setInstallments] = useState([]);
  const [installmentOpen, setInstallmentOpen] = useState(false);
  const [isLoadingInstallments, setIsLoadingInstallments] = useState(false);
  const [addInstallmentOpen, setAddInstallmentOpen] = useState(0);
  const [installmentId, setInstallmentId] = useState();
  const [payInstallment, setPayInstallment] = useState(false);
  const [fetchedFunders, setFunders] = useState([]);
  const [activityTemp, setActivityTemp] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(null);
  const [descriptionDialogOpen, setDescriptionDialogOpen] = useState(false);

  const delId = getQuery("deliverableId");

  const fetchPartners = async (activityId) => {
    const resp = await FetchDetails(
      `/api/partner/assigned?activityId=${activityId}`
    );
    if (resp.status) {
      setPartners(resp?.data?.data);
    }
  };

  const fetchFunders = async (activityId) => {
    const resp = await FetchDetails(
      `/api/funder/assigned?activityId=${activityId}`
    );
    if (resp?.status) {
      setFunders(resp?.data?.data);
      // set installments on activity
    }
  };

  const fecthActivity = async (id) => {
    const task = await FetchDetails(`/api/activity/details/${id}`);
    if (task.status) {
      setActivityTemp(task?.data?.data);
      // update activity in list od activities
      const temp = activities.map((v) => {
        if (v.id === id) {
          return task?.data?.data;
        }
        return v;
      });
      setActivities(temp);
    }
  };

  const fetchInstallments = async (id, { type }) => {
    if (type === "funder") {
      setValue0("funderId", id);
    } else {
      setValue0("partnerId", id);
    }
    const installments = await FetchDetails(
      type == "funder"
        ? `/api/installment/list?funderId=${id}`
        : `/api/installment/list?partnerId=${id}`
    );
    setInstallments(installments?.data?.data);
    setValue0("installment", installments?.data?.data?.length);
  };

  // const activitiesTotal = () => {
  //   return activities?.reduce((prev, v) => parseInt(v.budget) + prev, 0);
  // };

  // const handleChange = async (event, newValue) => {
  //   if (newValue === 1) {
  //     setActivity(activity);
  //   }
  //   setTabValue(newValue);
  // };

  const setInitInfo = () => {
    const reducerDeliveryNo = deliverables?.reduce(
      (prev, v) => Math.max(v.deliveryNo, prev),
      0
    );
    setValue0("deliveryNo", reducerDeliveryNo + 1);

    setMaxBudget(
      parseInt(project.budget) - parseInt(totalAllocatedBudget ?? 0)
    );
  };

  useEffect(() => {
    setInitInfo();
  }, [info, projectId]);

  useEffect(async () => {
    await fecthActivity(activity?.id);
    await fetchPartners(activity?.id);
    await fetchFunders(activity?.id);
  }, [activity]);

  const setValue0 = (name, val) => {
    if (!name) {
      return null;
    }

    setValue((v) => {
      v[name] = val;
      return { ...v };
    });
  };

  const assignTeam = async () => {
    if (!selectedDev.length) {
      errorToast("Select at least one project member !");
      return;
    }

    setAssigning(true);
    const resp = await axios.post(
      // `/api/project/deliverable/assign/team/${deliverable.id}`,
      `/api/activity/assign/team/${activity.id}`,
      { team: selectedDev }
    );
    if (resp.status) {
      await onSuccess();
      successToast(getSuccessMessage(resp));
      setAssignOpen(false);
    } else {
      errorToast(getError(resp));
    }
    setAssigning(false);
  };

  const onSuccess = () => setCount((v) => v + 1);

  const teamItem = (resource) => {
    const onClick = () => {
      if (selectedDev.filter((v) => v === resource.id).length > 0) {
        setSelectedDev((old) => old.filter((i) => i !== resource.id));
      } else {
        setSelectedDev((old) => [...old, resource.id]);
      }
    };

    let checked = selectedDev.filter((v) => v === resource.id).length > 0;

    return (
      <div className={`mr-2 relative mb-2`}>
        <div
          className={"absolute right-0"}
          style={{ zIndex: "10", top: "-10px" }}
        >
          <Checkbox onChange={onClick} checked={checked} />
        </div>
        <CardActionArea onClick={onClick}>
          <StyledBadge
            overlap="circular"
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            // variant="dot"
          >
            <Avatar
              sx={{ bgcolor: grey[300], width: 60, height: 60 }}
              alt={resource.names}
              src={
                resource.profile
                  ? `${downloadUrl}/${resource.profile}`
                  : undefined
              }
            />
          </StyledBadge>
          <div style={{ width: "130px" }}>
            <Typography
              sx={{
                display: "-webkit-box",
                overflow: "hidden",
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: 1,
              }}
              variant={"body2"}
            >
              {resource.names}
            </Typography>
            <div>
              <Typography
                sx={{
                  display: "-webkit-box",
                  overflow: "hidden",
                  WebkitBoxOrient: "vertical",
                  WebkitLineClamp: 1,
                }}
                variant={"subtitle2"}
                style={{ fontWeight: "bold" }}
              >
                {resource.category}
              </Typography>
            </div>
          </div>
        </CardActionArea>
      </div>
    );
  };

  const columns = [
    {
      name: "name",
      label: "Name",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <span className="text-custom-blue text-xs ">{value}</span>
        ),
      },
    },
    {
      name: "budget",
      label: "Budget",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <span className="text-custom-blue text-xs ">{value}</span>
        ),
      },
    },
    {
      name: "completionPercentage",
      label: "Perfomance",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <span className="text-custom-blue text-xs ">{    value
            ? `${parseFloat(value).toFixed(2)}%`
            : "0%"}</span>
        ),
      },
    },
    {
      name: "startDate",
      label: "Start Date",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <span className="text-[#A1A1A1] text-xs">
            {moment(value).format("DD/MM/yyyy") ?? ""}
          </span>
        ),
      },
    },
    {
      name: "endDate",
      label: "End Date",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <span className="text-[#A1A1A1] text-xs">
            {moment(value).format("DD/MM/yyyy") ?? ""}
          </span>
        ),
      },
    },
    {
      name: "impact",
      label: "Impact",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <span className="text-[#A1A1A1] text-xs font-lighter">{value}</span>
        ),
      },
    },
    {
      name: "creator.names",
      label: "Created By",
    },
    {
      name: "id",
      label: "Status",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (id) => {
          const currentActvity = activities.find((e) => e.id === id);
          return (
            <span style={{ fontSize: "0.85rem" }}>
              <StatusLayout status={currentActvity?.status} />
            </span>
          );
        },
      },
    },
  ];

  return (
    <div>
      <FormDialog
        maxWidth={"md"}
        col={6}
        open={open > 0}
        onSuccess={async () => {
          onSuccess();
          await fecthActivity();
        }}
        setOpen={setOpen}
        url={open === 1 ? `/api/activity/create` : `/api/activity/update/${id}`}
        title={open === 1 ? "Create New Activity" : "Update Activity"}
        fields={[
          {
            name: "name",
            label: "Activity Name",
            value: value["name"],
            required: true,
            col: 12,
            setValue: (val) => setValue0("name", val),
          },
          {
            name: "startDate",
            label: "Start",
            value: value["startDate"],
            required: true,
            // type: "date",
            type: "datetime-local",
            setValue: (val) => setValue0("startDate", val),
            // min: moment(project?.startDate).format("YYYY-MM-DD"),
            // max: moment(project?.endDate).format("YYYY-MM-DD"),
            validate: (v) => {
              if (
                project?.startDate &&
                moment(v).isBefore(moment(project.startDate))
              ) {
                return (
                  "Start date cannot be before: " +
                  moment(project.startDate).format("YYYY-MM-DD HH:mm")
                );
              }
              if (
                project?.endDate &&
                moment(v).isAfter(moment(project.endDate))
              ) {
                return (
                  "Start date cannot be after: " +
                  moment(project.endDate).format("YYYY-MM-DD HH:mm")
                );
              }
              return true;
            },
          },
          {
            name: "endDate",
            label: "End",
            value: value["endDate"],
            required: true,
            type: "datetime-local",
            setValue: (val) => setValue0("endDate", val),
            minDate: value["startDate"] ? moment(value["startDate"]) : null,
            validate: (v) => {
              if (
                project?.startDate &&
                moment(v).isBefore(moment(project.startDate))
              ) {
                return (
                  "End date cannot be before: " +
                  moment(project.startDate).format("YYYY-MM-DD HH:mm")
                );
              }
              if (
                project?.endDate &&
                moment(v).isAfter(moment(project.endDate))
              ) {
                return (
                  "End date cannot be after: " +
                  moment(project.endDate).format("YYYY-MM-DD HH:mm")
                );
              }
              return true;
            },
          },
          {
            name: "budget",
            label:
              project?.budgetType === "restricted"
                ? `Budget (max is ${maxBudget})`
                : "Budget",
            value: value["budget"],
            required: true,
            isNumber: true,
            type: "number",
            max: project?.budgetType === "restricted" ? maxBudget : null,
            setValue: (val) => {
              if (project?.budgetType === "restricted") {
                if (parseFloat(val) > parseFloat(maxBudget)) {
                  setValue0("budget", maxBudget);
                  return;
                } else {
                  setValue0("budget", val);
                }
              } else {
                setValue0("budget", val);
              }
            },
          },
          // {
          //   name: "expenses",
          //   label: "Expenditure",
          //   value: value["expenses"],
          //   options: {
          //     filter: true,
          //     sort: true,
          //     customBodyRender: (value) => (
          //       <span className="text-[#A1A1A1] text-xs font-lighter">
          //         {value}
          //       </span>
          //     ),
          //   },
          //   setValue: (val) => setValue0("expenses", val),
          // },
          {
            name: "impact",
            label: "Impact",
            type: "select",
            values: [
              { label: "High", value: "high" },
              { label: "Medium", value: "medium" },
              { label: "Low", value: "low" },
            ],
            value: value["impact"],
            setValue: (val) => setValue0("impact", val),
          },
          {
            name: "projectId",
            label: "Project",
            value: project?.id,
            required: false,
            type: "text",
            hidden: true,
            setValue: (val) => setValue0("projectId", val),
          },
          {
            name: "description",
            label: "Description",
            value: value["description"],
            type: "textarea",
            col: 12,
            setValue: (val) => setValue0("description", val),
          },
        ]}
      />

      <Dialog
        open={installmentOpen}
        onClose={() => setInstallmentOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <div className="flex justify-between items-center">
            <h2>Installment(s)</h2>
            <IconButton onClick={() => setInstallmentOpen(false)}>
              <img
                src={require("../../assets/icons/close.svg").default}
                alt="Decorative SVG"
                className="w-6 h-6"
              />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent>
          <div className="flex flex-col justify-between items-center">
            {!isLoadingInstallments && installments?.length > 0 ? (
              <table className="w-full">
                <thead>
                  <tr>
                    <th className="text-left"></th>
                    <th className="text-left">Amount</th>
                    <th className="text-left">Due Date</th>
                    <th className="text-left">Status</th>
                    <th className="text-left">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {installments.map((v, i) => (
                    <tr
                      style={{
                        backgroundColor: i % 2 === 0 ? "#f9f9f9" : "#fff",
                        marginTop: "10px",
                      }}
                      key={i}
                    >
                      <td>Installment {i + 1}</td>

                      <td>{v.amount}</td>

                      <td>{moment(v.dueDate).format("DD/MM/YYYY")}</td>
                      <td>
                        <StatusLayout status={v.status} />
                      </td>
                      <td>
                        <IconButton
                          onClick={() => {
                            setValue0("partnerId", v.partnerId);
                            setValue0("amount", v.amount);
                            setValue0(
                              "dueDate",
                              moment(v.dueDate).format("YYYY-MM-DD")
                            );
                            setValue0("status", v.status);
                            if (v.status === "paid") {
                              setPayInstallment(true);
                              setValue0(
                                "paidDate",
                                moment(v.paidDate).format("YYYY-MM-DD")
                              );
                            } else {
                              setPayInstallment(false);
                              setValue0("paidDate", null);
                            }
                            setInstallmentId(v.id);

                            setAddInstallmentOpen(2);
                          }}
                        >
                          <img
                            src={
                              require("../../assets/icons/pencil.svg").default
                            }
                            alt="Decorative SVG"
                            className="w-5 h-5"
                          />
                        </IconButton>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : isLoadingInstallments ? (
              <div className="flex justify-center items-center w-full">
                <p>Loading Installments...</p>
              </div>
            ) : (
              <div className="flex justify-center items-center w-full">
                <p>No Installments Found</p>
              </div>
            )}

            <div className="flex justify-center items-center w-full mt-4">
              <QtMaterialButton
                onClick={() => {
                  // setValue0("funderId", id);
                  setAddInstallmentOpen(1);
                }}
                className="mt-4"
                variant="contained"
                color="primary"
                size="small"
              >
                Add Installment
              </QtMaterialButton>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      <FormDialog
        maxWidth={"md"}
        col={6}
        open={addInstallmentOpen > 0}
        onSuccess={async () => {
          await fetchInstallments(value["funderId"] ?? value["partnerId"], {
            type: value["partnerId"] ? "partner" : "funder",
          });
          // setAddInstallmentOpen(0);
          await fetchPartners(activity?.id);
          setActivity(activity);
        }}
        setOpen={setAddInstallmentOpen}
        url={
          addInstallmentOpen === 1
            ? "/api/installment/create"
            : `/api/installment/update/${installmentId}`
        }
        title={
          addInstallmentOpen === 1 ? "Add Installment" : "Edit Installment"
        }
        fields={[
          {
            name: "partnerId",
            label: "Partner",
            value: value["partnerId"],
            hidden: true,
            required: true,
            col: 12,
            setValue: (val) => setValue0("partnerId", val),
          },
          {
            name: "funderId",
            label: "Funder",
            value: value["funderId"],
            hidden: true,
            required: true,
            col: 12,
            setValue: (val) => setValue0("funderId", val),
          },
          {
            name: "amount",
            label: "Amount",
            value: value["amount"],
            type: value["fundType"] === "full" ? "text" : "number",
            isNumber: true,
            disabled: value["fundType"] === "full",
            setValue: (val) => {
              setValue0("amount", val);
            },
          },
          {
            name: "dueDate",
            label: "Due Date",
            value: value["dueDate"],
            type: "date",
            required: true,
            setValue: (val) => setValue0("dueDate", val),
          },
          {
            name: "paymentStatus",
            label: "Want to Mark as Paid?",

            value: payInstallment ? "yes" : "no",
            hidden: addInstallmentOpen === 1,
            values: [
              { label: "Yes", value: "yes" },
              { label: "No", value: "no" },
            ],
            type: "radio",
            col: 12,
            setValue: (val) => {
              if (val === "yes") {
                setPayInstallment(true);
              } else {
                setPayInstallment(false);
              }
            },
          },
          // select status and date
          {
            name: "status",
            label: "Payment Status",
            value: value["status"],
            type: "select",
            hidden: addInstallmentOpen === 1 || !payInstallment,
            values: [
              { label: "Pending", value: "pending" },
              { label: "Paid", value: "paid" },
            ],
            required: true,
            setValue: (val) => {
              setValue0("status", val);
            },
          },
          {
            name: "paidDate",
            label: "Paid Date",
            value: value["paidDate"],
            type: "date",
            hidden: addInstallmentOpen === 1 || !payInstallment,

            setValue: (val) => setValue0("paidDate", val),
          },
        ]}
      />

      <FormDialog
        maxWidth={"md"}
        col={6}
        open={addFunder > 0}
        onSuccess={async () => {
          await fetchFunders(activity?.id);
          setAddFunder(0);
        }}
        setOpen={() => {
          setAddFunder(0);
        }}
        url={
          addFunder === 2
            ? "/api/funder/assign"
            : `/api/funder/assign/update/${id}`
        }
        title={addFunder === 2 ? "Assign Funder" : "Edit Assigned Funder"}
        fields={[
          {
            name: "funderId",
            label: "Funder",
            value: value["funderId"],
            values: funders?.map((v) => {
              return { label: v?.funder?.name, value: v?.funder?.id };
            }),
            type: "select",
            required: true,
            col: 12,
            setValue: (val) => setValue0("funderId", val),
          },

          {
            name: "fundType",
            label: "Funding Type",
            value: value["fundType"],
            type: "radio",
            values: [
              { label: "Partially", value: "partial" },
              { label: "Full", value: "full" },
            ],
            required: true,
            col: 12,
            setValue: (val) => {
              if (val === "full") {
                setValue0("amount", activity?.budget);
              } else {
                setValue0("amount", 0);
              }
              setValue0("fundType", val);
            },
          },
          {
            name: "amount",
            label: "Amount",
            value: value["amount"],
            max: activity?.budget,
            type: value["fundType"] === "full" ? "text" : "number",
            isNumber: true,
            disabled: value["fundType"] === "full",
            setValue: (val) => {
              if (parseFloat(val) > parseFloat(activity?.budget)) {
                setValue0("amount", activity?.budget);
                return;
              } else {
                setValue0("amount", val);
              }
            },
          },

          {
            name: "activityId",
            label: "Program",
            value: activity?.id,
            required: false,
            type: "text",
            hidden: true,
            setValue: (val) => setValue0("activityId", val),
          },

          {
            name: "currency",
            label: "Currency",
            value: value["currency"],
            type: "select",
            values: currencyValues,
            required: true,
            setValue: (val) => setValue0("currency", val),
          },
        ]}
      />

      <WorklogManager
        deliverableId={id}
        open={logOpen}
        setOpen={() => setLogOpen(false)}
        activityId={activity?.id}
        canViewAll={canEdit}
      />

      <Dialog open={assignOpen} onClose={() => setAssignOpen(false)}>
        <DialogTitle>Assign Team to this Activity</DialogTitle>
        <DialogContent>
          <div className={"flex flex-wrap text-center justify-center"}>
            {info?.assignees?.map((v) => teamItem(v.Resource))}
          </div>
          <div className={"text-center mt-3"}>
            {assigning ? (
              <CircularProgress />
            ) : (
              <>
                <div>
                  <Button
                    sx={{
                      backgroundColor: mainBackground,
                      color: "white",
                      "&:hover": {
                        backgroundColor: mainBackground,
                      },
                    }}
                    variant={"contained"}
                    onClick={assignTeam}
                  >
                    Assign Team
                  </Button>
                </div>
                <div>
                  <Button onClick={() => setAssignOpen(false)}>Cancel</Button>
                </div>
              </>
            )}
          </div>
        </DialogContent>
      </Dialog>
      <DeleteDialog
        open={deleteOpen}
        setOpen={() => {
          setDeleteOpen(false);
          setSuccess(0);
        }}
        onSuccess={onSuccess}
        // info={success}
        title={"Are you sure you want to delete this activity?"}
        url={`/api/activity/delete/${id}`}
      />

      {/* padd partner form  */}

      <FormDialog
        maxWidth={"md"}
        col={6}
        open={addPartner > 0}
        onSuccess={async () => {
          await fetchPartners(activity.id);
        }}
        setOpen={setAddPartner}
        url={
          addPartner === 1
            ? "/api/partner/assign"
            : `/api/partner/assign/update/${partnerId}`
        }
        title={addPartner === 1 ? "Assign Partner" : "Edit Assign Partner"}
        fields={[
          {
            name: "partnerId",
            label: "Partner",
            value: value["partnerId"],
            values: partners?.map((v) => {
              return { label: v?.partner?.name, value: v?.partner?.id };
            }),
            type: "select",
            required: true,
            col: 12,
            setValue: (val) => {
              if (val !== null || val !== undefined || val !== "") {
                const selectedPartner = partners.find(
                  (v) => v?.partner?.id === val
                );
                setValue0("partnerId", selectedPartner?.partner?.id ?? val);
              }
            },
          },

          {
            name: "partnerType",
            label: "Partner Type",
            value: value["partnerType"],
            type: "radio",
            values: [
              { label: "Partially", value: "partial" },
              { label: "Full", value: "full" },
            ],
            required: true,

            col: 12,
            setValue: (val) => {
              if (val === "full") {
                setValue0("amount", activity?.budget);
              } else {
                setValue0("amount", 0);
              }
              setValue0("partnerType", val);
            },
          },
          {
            name: "amount",
            label: "Amount",
            value: value["amount"],
            max: activity?.budget,
            type: value["partnerType"] === "full" ? "text" : "number",
            isNumber: true,
            disabled: value["partnerType"] === "full",
            setValue: (val) => {
              // errorToast("Amount cannot be greater than budget");
              // setValue0("amount", 0);

              // if(value["partnerId"] === null || value["partnerId"] === undefined || value["partnerId"] === ""){
              //   errorToast("Please select a partner first");
              //   return;
              // }
              //  const selectedPartner = partners.find((v) => v.partner.id === value["partnerId"]);
              //   if(selectedPartner){
              // check if
              setValue0("amount", val);
            },
          },
          // {
          //   name: "installment",
          //   label: "How many installments",
          //   value: value["installment"],
          //   hidden: value["amount"] === 0 || value["amount"] === null || value["amount"] === undefined || addPartner === 2,
          //   type: "number",
          //   setValue: (val) => {
          //     setValue0("installment", val);
          //     // set installment values amount , due date,
          //     // check existing installments
          //     // if installments are already set, then set the new value
          //     if (installments?.length > 0 && parseInt(value["installment"]) > 0) {
          //       // get existing installments
          //       // check if the number of installments is less than the new value
          //       if (installments?.length < val) {
          //         // add new installments
          //         setInstallments([
          //           ...installments,
          //           ...Array.from({ length: val - installments?.length }, (_, i) => ({
          //             amount: 0,
          //             dueDate: 0,
          //           }))
          //         ])
          //       } else {
          //         // remove extra installments
          //         setInstallments(installments.slice(0, val))
          //       }

          //     } else {
          //       // get budget
          //       var num = value["amount"] / val;

          //       setInstallments(
          //         Array.from({ length: val }, (_, i) => ({
          //           amount: num,
          //           dueDate: 0,
          //         }))
          //       )
          //     }
          //   },
          // },

          {
            name: "activityId",
            label: "Program",
            value: activity?.id,
            required: false,
            type: "text",
            hidden: true,
            setValue: (val) => setValue0("activityId", val),
          },

          {
            name: "currency",
            label: "Currency",
            value: value["currency"],
            type: "select",
            values: currencyValues,
            required: true,
            setValue: (val) => setValue0("currency", val),
          },
        ]}
        // add installments based on the number of installments

        showAdditionalContent={false}
        additionalContent={
          <div className="flex flex-col gap-2">
            <p className="text-gray-500 font-light flex items-center gap-2">
              Installments
            </p>
            <div className=" w-full flex flex-col gap-2">
              {value["installment"] > 0 && (
                <div className="w-full flex flex-col gap-2">
                  {Array.from({ length: value["installment"] }, (_, i) => (
                    <div
                      key={i}
                      className="w-11/12 flex justify-around items-center gap-2"
                    >
                      <p>Installment {i + 1}</p>
                      <div>
                        <label
                          style={{ color: "#333333" }}
                          className={`block uppercase text-xs font-normal "mb-2"
                    `}
                          htmlFor={`installment${i + 1}`}
                        >
                          Amount
                        </label>
                        <input
                          key={i}
                          type="number"
                          // min={0}
                          max={parseFloat(value["amount"])}
                          className="px-3 py-3 border-input placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                          placeholder="Amount"
                          value={installments[i]?.amount}
                          onChange={(e) => {
                            // set value in installments array
                            const newInstallments = [...installments];

                            // validate amount
                            var amount = 0;
                            for (let j = 0; j < newInstallments.length; j++) {
                              if (j !== i) {
                                amount += parseFloat(newInstallments[j].amount);
                              }
                            }

                            if (
                              parseFloat(e.target.value) >
                              parseFloat(value["amount"])
                            ) {
                              // set it to previous value
                              setInstallments(newInstallments);

                              return;
                            }
                            if (
                              parseFloat(e.target.value) + amount >
                              parseFloat(value["amount"])
                            ) {
                              // adjust other installments to equal to the total amount

                              // get axceeded amount and remove it to the other installments
                              var exceededAmount =
                                parseFloat(e.target.value) +
                                amount -
                                parseFloat(value["amount"]);
                              const newAmount = amount - exceededAmount;
                              for (let j = 0; j < newInstallments.length; j++) {
                                if (j !== i) {
                                  newInstallments[j].amount = parseFloat(
                                    newAmount / (newInstallments.length - 1)
                                  );
                                }
                              }

                              newInstallments[i].amount = e.target.value;
                              setInstallments(newInstallments);
                            } else {
                              // if amount is less than  increase amount of other installments
                              if (
                                parseFloat(e.target.value) + amount <
                                parseFloat(value["amount"])
                              ) {
                                var exceededAmount =
                                  parseFloat(value["amount"]) -
                                  (parseFloat(e.target.value) + amount);
                                const newAmount = amount + exceededAmount;
                                for (
                                  let j = 0;
                                  j < newInstallments.length;
                                  j++
                                ) {
                                  if (j !== i) {
                                    newInstallments[j].amount = parseFloat(
                                      newAmount / (newInstallments.length - 1)
                                    );
                                  }
                                }
                              }

                              newInstallments[i].amount = e.target.value;
                              setInstallments(newInstallments);
                            }
                          }}
                        />
                      </div>
                      {/* due date */}
                      <div>
                        <label
                          style={{ color: "#333333" }}
                          className={`block uppercase text-xs font-normal "mb-2"
                    `}
                          htmlFor={`installment${i + 1}`}
                        >
                          Due Date
                        </label>
                        <input
                          type="date"
                          className="px-3 py-3 border-input placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                          placeholder="Due Date"
                          value={
                            installments[i]?.dueDate ??
                            moment(installments[i]?.dueDate).format(
                              "YYYY-MM-DD"
                            )
                          }
                          onChange={(e) => {
                            // set value in installments array
                            const newInstallments = [...installments];
                            newInstallments[i].dueDate = e.target.value;
                            setInstallments(newInstallments);
                          }}
                        />
                      </div>
                      <div>
                        <IconButton
                          onClick={() => {
                            // remove installment from installments array
                            const newInstallments = [...installments];
                            newInstallments.splice(i, 1);
                            setInstallments(newInstallments);
                            setValue0("installment", newInstallments.length);
                          }}
                        >
                          <DeleteOutline />
                        </IconButton>
                        {/* edit */}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        }
        // customSubmit={
        //   async () => {
        //     let data = {}
        //     data.installments = installments;
        //     data.activityId = activity.id;
        //     data.amount = value["amount"];
        //     data.currency = value["currency"];
        //     data.partnerType = value["partnerType"];
        //     data.partnerId = value["partnerId"];
        //     const resp = await SubmitGeneralForm(
        //       addPartner === 1
        //         ? `/api/partner/assign`
        //         : `/api/partner/assign/update/${partnerId}`,
        //       data,
        //       "POST"
        //     );
        //     if (resp.status) {
        //       successToast(getSuccessMessage(resp));
        //          await fetchPartners(activity.id);
        //   setAddPartner(0);
        //     } else {
        //       setAddPartner(0);
        //       errorToast(getError(resp));
        //     }
        //   }
        // }
      />

      {/* // partners dialog */}
      <Dialog
        open={partnersOpen}
        onClose={() => setPartnersOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <div className="flex justify-between items-center">
            <h2>Partner(s)</h2>
            <IconButton onClick={() => setPartnersOpen(false)}>
              <img
                src={require("../../assets/icons/close.svg").default}
                alt="Decorative SVG"
                className="w-6 h-6"
              />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent>
          <div className="flex flex-col justify-between items-center">
            {!isLoadingPartners && fetchedPartners?.length > 0 ? (
              <table className="w-full">
                <thead>
                  <tr>
                    <th className="text-left">#</th>
                    <th className="text-left">Name</th>
                    <th className="text-left">Type</th>
                    <th className="text-left">Amount</th>
                    <th className="text-left">Received Amount</th>
                    <th className="text-left">Currency</th>
                    <th className="text-left">Status</th>
                    <th className="text-left">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {fetchedPartners.map((v, i) => (
                    <tr
                      style={{
                        backgroundColor: i % 2 === 0 ? "#f9f9f9" : "#fff",
                        marginTop: "10px",
                      }}
                      key={i}
                    >
                      <td>{i + 1}</td>

                      <td>{v?.partner?.name}</td>
                      <td>{v?.partnerType}</td>

                      <td>{v.amount}</td>
                      <td>{v?.receivedAmount}</td>
                      <td>{v?.currency}</td>

                      <td>
                        <StatusLayout status="pending" />
                      </td>
                      <td>
                        <IconButton
                          onClick={() => {
                            setValue0("partnerId", v?.partner?.id);
                            setValue0("amount", v.amount);
                            setValue0("receivedAmount", v?.receivedAmount);
                            setValue0("currency", v?.currency);
                            setValue0("partnerType", v?.partnerType);
                            setPartnerId(v.id);
                            //  setAddInstallmentOpen(2);
                            setAddPartner(2);
                          }}
                        >
                          <img
                            src={
                              require("../../assets/icons/pencil.svg").default
                            }
                            alt="Decorative SVG"
                            className="w-5 h-5"
                          />
                        </IconButton>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : isLoadingPartners ? (
              <div className="flex justify-center items-center w-full">
                <p>Loading Partners...</p>
              </div>
            ) : (
              <div className="flex justify-center items-center w-full">
                <p>No Partner Found</p>
              </div>
            )}
          </div>
        </DialogContent>
      </Dialog>

      <DeleteDialog
        open={paid ? paid : progress}
        setOpen={() => {
          setPaid(false);
          setProgress(false);
        }}
        onSuccess={async () => {
          await fecthActivity(activity?.id);
        }}
        info={true}
        title={paid ? "Payment Status" : "Progress Status"}
        bodyText={
          <div className={"py-3 text-left"}>
            <FormControl fullWidth={true} size={"small"}>
              <InputLabel id="demo-simple-select-label">Status</InputLabel>
              {progress ? (
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={status}
                  label="Status"
                  onChange={(e) => setStatus(e.target.value)}
                >
                  <MenuItem value={"to-do"}>To Do</MenuItem>

                  <MenuItem value={"in-progress"}>In Progress</MenuItem>
                  <MenuItem value={"under-review"}>Under Review</MenuItem>
                  <MenuItem value={"completed"}>Completed</MenuItem>
                </Select>
              ) : (
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={status}
                  label="Status"
                  onChange={(e) => setStatus(e.target.value)}
                >
                  <MenuItem value={"NOT-PAID"}>Not Paid</MenuItem>
                  <MenuItem value={"waiting_invoice"}>
                    Waiting For Invoice
                  </MenuItem>
                  <MenuItem value={"waiting_payment"}>
                    Waiting For Payment
                  </MenuItem>
                  <MenuItem value={"paid"}>Paid</MenuItem>
                </Select>
              )}
            </FormControl>
          </div>
        }
        url={`/api/activity/${activity?.id}/change-status?status=${status}`}
      />
      <DeleteDialog
        open={mergeOpen}
        setOpen={() => {
          setMergeOpen(false);
        }}
        onSuccess={onSuccess}
        info={true}
        title={"Merge This deliverable"}
        bodyText={
          <div>
            <Alert severity={"warning"}>
              Tasks that belong to this deliverable will be moved into selected
              deliverable below and this deliverable will be deleted
            </Alert>
            <div className={"py-3 text-left"}>
              {/* <FormControl fullWidth={true} size={'small'}>
                        <InputLabel id="demo-simple-select-label">Select deliverable</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={mergerIntoId}
                            label="Deliverable"
                            onChange={(e) => setMergeIntoId(e.target.value)}
                        >
                            {deliverables?.filter(v => v.id !== id)?.map(v =>
                                <MenuItem value={v.id}>{v.title}</MenuItem>)}
                        </Select>
                    </FormControl> */}
            </div>
          </div>
        }
        url={`/api/project/deliverable/merge/${id}/${mergerIntoId}`}
      />
      <div className={""}>
        <DatatableComponent
          onRowClick={(data, { rowIndex }) => {}}
          onAddNew={
            !loggedUser?.isPartner
              ? () => {
                  if (project?.budgetType === "restricted" && maxBudget === 0) {
                    errorToast(
                      "You cannot add new activity, because your project has no budget left"
                    );
                    return;
                  }
                  setOpen(1);
                }
              : null
          }
          processData={(data) => {
            setActivities(data?.data);
            return data;
          }}
          onRowSelectionChange={(list) => {}}
          search={false}
          viewColumns={false}
          elevation={1}
          pdf={false}
          excel={false}
          searchfield={true}
          columns={columns}
          expandableRows={true}
          renderExpandableRow={(rowData, rowMeta) => {
            const current = rowMeta?.dataIndex ?? 0;

            const activityData = activities[current];
            if (current !== currentIndex) {
              setActivity(activityData);
            }

            setCurrentIndex(current);

            return (
              <tr>
                <td colSpan={12}>
                  <div className="w-full">
                    <AccordionSummary>
                      <div className="w-full p-6 bg-white border border-gray-200 rounded-lg shadow-sm">
                        <div className="w-full flex gap-4 justify-between items-start">
                          <div className="w-[20%]  flex flex-col gap-6 justify-around">
                            <div className="">
                              <p className="text-gray-500 font-light flex items-center gap-2 text-[14px]">
                                Budget
                              </p>
                              <p className="font-semibold text-[13px]">
                                {activityTemp?.budget ?? activity?.budget}
                              </p>
                            </div>
                          </div>
                          <div className="space-y-2  w-[20%] flex flex-col gap-6 justify-around">
                            <div className="">
                              <p className="text-gray-500 font-light flex items-center gap-2 text-[14px]">
                                Expenditure
                              </p>
                              <p className="font-semibold text-[13px]">
                                {activityTemp?.expenses ?? activity?.expenses}
                              </p>
                            </div>
                          </div>
                          <div className="space-y-2  w-[20%] flex flex-col gap-6 justify-around">
                            <div className="">
                              <p className="text-gray-500 font-light flex items-center gap-2 text-[14px]">
                                Balance
                              </p>
                              <p className="font-semibold text-[13px]">
                                {(activityTemp?.budget ?? activity?.budget) -
                                  (activityTemp?.expenses ??
                                    activity?.expenses)}
                              </p>
                            </div>
                          </div>
                          <div className="w-[40%] ">
                            <p className="text-gray-700 font-semibold text-[14px]">
                              Activity Description
                            </p>
                            <div className="text-gray-600 w-full font-normal text-sm">
                              {(
                                activityTemp?.description ??
                                activity?.description
                              )?.length > 100 ? (
                                <>
                                  {(
                                    activityTemp?.description ??
                                    activity?.description
                                  )?.substring(0, 100)}
                                  ...
                                  <Button
                                    size="small"
                                    onClick={() =>
                                      setDescriptionDialogOpen(true)
                                    }
                                    sx={{
                                      textTransform: "none",
                                      color: mainBackground,
                                      "&:hover": {
                                        backgroundColor: "transparent",
                                        textDecoration: "underline",
                                      },
                                    }}
                                  >
                                    View more
                                  </Button>
                                </>
                              ) : (
                                activityTemp?.description ??
                                activity?.description
                              )}
                            </div>
                          </div>

                          <Dialog
                            open={descriptionDialogOpen}
                            onClose={() => setDescriptionDialogOpen(false)}
                            maxWidth="sm"
                            fullWidth
                          >
                            <DialogContent>
                              <div className={"flex items-center"}>
                                <div className={"flex-grow font-bold text-lg"}>
                                  <Typography variant="h6" className="mb-3">
                                    Activity Description
                                  </Typography>
                                </div>
                                <IconButton
                                  onClick={() => {
                                    setDescriptionDialogOpen(false);
                                  }}
                                >
                                  <img
                                    src={
                                      require("assets/icons/close.svg").default
                                    }
                                    alt={"close"}
                                  />
                                </IconButton>
                              </div>

                              <Typography variant="body1">
                                {activityTemp?.description ??
                                  activity?.description}
                              </Typography>
                            </DialogContent>
                          </Dialog>
                        </div>
                        {!loggedUser?.isPartner && (
                          <div className="mt-6">
                            <div className="grid grid-cols-2 gap-4">
                              {/* Funder Card */}
                              <div className="bg-white rounded-lg shadow-sm p-3 border border-gray-100">
                                {!fetchedFunders ||
                                fetchedFunders?.length === 0 ? (
                                  <div className="flex flex-col justify-center items-center py-4">
                                    <p className="text-gray-500 mb-2 text-sm">
                                      No Funder Assigned
                                    </p>
                                    <Button
                                      onClick={() => {
                                        setDeliverable(activity);
                                        setAddFunder(2);
                                        setActivity(activity);
                                        setValue0("currency", "rwf");
                                      }}
                                      style={{
                                        backgroundColor: mainBackground,
                                        borderRadius: "10px",
                                        padding: "8px 16px",
                                        color: "#fff",
                                      }}
                                      variant="contained"
                                      size="small"
                                    >
                                      Assign Funder
                                    </Button>
                                  </div>
                                ) : (
                                  <div>
                                    {fetchedFunders.map((funder, index) => (
                                      <div key={index}>
                                        <div className="flex justify-between items-center mb-2">
                                          <div>
                                            <h3 className="text-[14px] font-semibold text-gray-800">
                                              {funder?.funder?.name}
                                            </h3>
                                            <p className="text-xs text-gray-500">
                                              Funder
                                            </p>
                                          </div>
                                          <div className="flex items-center gap-2">
                                            <Button
                                              sx={{
                                                textTransform: "none",
                                                fontSize: "0.75rem",
                                                padding: "4px 8px",
                                                backgroundColor: "#F3F4F6",
                                                color: "#4B5563",
                                                minWidth: "auto",
                                              }}
                                              onClick={async () => {
                                                setId(value);
                                                setInstallmentOpen(true);
                                                await fetchInstallments(
                                                  funder?.id,
                                                  { type: "funder" }
                                                );
                                              }}
                                              variant="contained"
                                              color="primary"
                                              size="small"
                                            >
                                              Installments (
                                              {funder?.installmentsCount ?? 0})
                                            </Button>
                                            <IconButton
                                              size="small"
                                              onClick={() => {
                                                setValue0(
                                                  "funderId",
                                                  funder?.funder?.id
                                                );
                                                setValue0(
                                                  "amount",
                                                  funder.amount
                                                );
                                                setValue0(
                                                  "currency",
                                                  funder?.currency
                                                );
                                                setValue0(
                                                  "fundType",
                                                  funder?.fundType
                                                );
                                                setId(funder.id);
                                                setActivity(activity);
                                                setAddFunder(1);
                                              }}
                                            >
                                              <img
                                                src={
                                                  require("../../assets/icons/pencil.svg")
                                                    .default
                                                }
                                                alt="Edit"
                                                className="w-4 h-4"
                                              />
                                            </IconButton>
                                          </div>
                                        </div>

                                        <div className="grid grid-cols-2 gap-2">
                                          <div>
                                            <p className="text-[14px] text-gray-500">
                                              Amount
                                            </p>
                                            <p className="text-sm font-medium">
                                              {funder?.amount}{" "}
                                              {funder?.currency}
                                            </p>
                                          </div>
                                          <div>
                                            <p className="text-xs text-gray-500">
                                              Status
                                            </p>
                                            <p className="text-sm font-medium">
                                              {funder?.status}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>

                              {/* Partner Card */}
                              <div className="bg-white rounded-lg shadow-sm p-3 border border-gray-100">
                                {!isLoadingPartners &&
                                (!fetchedPartners ||
                                  fetchedPartners?.length === 0) ? (
                                  <div className="flex flex-col justify-center items-center py-4">
                                    <p className="text-gray-500 mb-2 text-sm">
                                      No Partner Assigned
                                    </p>
                                    <Button
                                      onClick={() => {
                                        var allocated = fetchedPartners?.reduce(
                                          (acc, v) => acc + v.amount,
                                          0
                                        );
                                        var remainingBudget =
                                          activity?.budget - allocated;
                                        if (remainingBudget <= 0) {
                                          errorToast("Budget is finished");
                                          return;
                                        }
                                        setValue0("partnerId", null);
                                        setValue0("amount", 0);
                                        setValue0("receivedAmount", 0);
                                        setValue0("currency", "rwf");
                                        setInstallments([]);
                                        setValue0("partnerType", null);
                                        setPartnerId(null);
                                        setActivity(activity);
                                        setAddPartner(1);
                                      }}
                                      style={{
                                        backgroundColor: mainBackground,
                                        borderRadius: "10px",
                                        padding: "8px 16px",
                                        color: "#fff",
                                      }}
                                      variant="contained"
                                      size="small"
                                    >
                                      Assign Partner
                                    </Button>
                                  </div>
                                ) : isLoadingPartners ? (
                                  <div className="flex justify-center items-center py-4">
                                    <p className="text-sm">
                                      Loading Partner...
                                    </p>
                                  </div>
                                ) : (
                                  <div>
                                    {fetchedPartners.map((partner, index) => (
                                      <div key={index}>
                                        <div className="flex justify-between items-center mb-2">
                                          <div>
                                            <h3 className="text-[13px] font-semibold text-gray-800">
                                              {partner?.partner?.name}
                                            </h3>
                                            <p className="text-xs text-gray-500 text-[14px]">
                                              Partner
                                            </p>
                                          </div>
                                          <div className="flex items-center gap-2">
                                            <Button
                                              sx={{
                                                textTransform: "none",
                                                fontSize: "0.75rem",
                                                padding: "4px 8px",
                                                backgroundColor: "#F3F4F6",
                                                color: "#4B5563",
                                                minWidth: "auto",
                                              }}
                                              onClick={async () => {
                                                setId(value);
                                                setInstallmentOpen(true);
                                                await fetchInstallments(
                                                  partner?.id,
                                                  { type: "partner" }
                                                );
                                              }}
                                              variant="contained"
                                              color="primary"
                                              size="small"
                                            >
                                              Installments (
                                              {partner?.installmentsCount ?? 0})
                                            </Button>
                                            <IconButton
                                              size="small"
                                              onClick={async () => {
                                                setValue0(
                                                  "partnerId",
                                                  partner?.partner?.id
                                                );
                                                setValue0(
                                                  "amount",
                                                  partner.amount
                                                );
                                                setValue0(
                                                  "receivedAmount",
                                                  partner?.receivedAmount
                                                );
                                                setValue0(
                                                  "currency",
                                                  partner?.currency
                                                );
                                                setValue0(
                                                  "partnerType",
                                                  partner?.partnerType
                                                );
                                                setPartnerId(partner.id);
                                                setAddPartner(2);
                                              }}
                                            >
                                              <img
                                                src={
                                                  require("../../assets/icons/pencil.svg")
                                                    .default
                                                }
                                                alt="Edit"
                                                className="w-4 h-4"
                                              />
                                            </IconButton>
                                          </div>
                                        </div>

                                        <div className="grid grid-cols-2 gap-2">
                                          <div>
                                            <p className="text-xs text-gray-500 text-[14px]">
                                              Type
                                            </p>
                                            <p className="text-sm font-medium">
                                              {partner?.partnerType}
                                            </p>
                                          </div>
                                          <div>
                                            <p className="text-xs text-gray-500">
                                              Amount
                                            </p>
                                            <p className="text-sm font-medium">
                                              {partner.amount}{" "}
                                              {partner?.currency}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Box sx={{ p: 2 }}>
                        <DndProvider
                          backend={HTML5Backend}
                          key={project?.id}
                          context={window}
                        >
                          <ProjectDndProvider
                            isInitiator={
                              project?.initiator === loggedUser?.resourceId ||
                              info
                            }
                            project={project}
                            deliverable={activity}
                            activity={activityTemp}
                            deliverables={activities}
                            PutAction={PutAction}
                            FetchDetails={FetchDetails}
                            onSuccess={() => {}}
                            tasksOfDelivery={activity?.tasks ?? []}
                            assignees={info?.assignees}
                            partners={fetchedPartners}
                            canEdit={canEdit}
                          />
                        </DndProvider>
                      </Box>
                    </AccordionDetails>

                    <div className="flex items-center justify-end w-full p-2 mt-2 gap-4">
                      <Button
                        onClick={() => {
                          setLogOpen(true);
                          setActivity(activity);
                        }}
                        style={{
                          backgroundColor: mainBackground,
                          borderRadius: "10px",
                          padding: "10px 20px",
                          color: "#fff",
                        }}
                        variant="contained"
                      >
                        Worklogs
                      </Button>
                      {!loggedUser?.isPartner && (
                        <>
                        {/* <Button
                            onClick={() => {
                              console.log("activity", activity);
                              setId(activity.id);
                              setDeliverable(activity);
                              setAssignOpen(true);
                            }}
                            style={{
                              backgroundColor: mainBackground,
                              borderRadius: "10px",
                              padding: "10px 20px",
                              color: "#fff",
                            }}
                            variant="contained"
                          >
                            <PersonAddAlt1Outlined className="mr-2" />
                            Assign Users
                          </Button> */}
                          <Button
                            onClick={() => {
                              setId(activity.id);
                              setValue({
                                name: activity.name,
                                startDate: moment(activity.startDate).utc().format(
                                  "YYYY-MM-DD HH:mm"
                                ),
                                endDate: moment(activity.endDate).utc().format(
                                  "YYYY-MM-DD HH:mm"
                                ),
                                budget: activity.budget,
                                expenses: activity.expenses,
                                description: activity.description,
                                patern: activity.patern,
                                impact: activity.impact,
                              });
                              setMaxBudget(
                                maxBudget + parseFloat(activity.budget)
                              );
                              setOpen(2);
                            }}
                            style={{
                              backgroundColor: mainBackground,
                              borderRadius: "10px",
                              padding: "10px 20px",
                              color: "#fff",
                            }}
                            variant="contained"
                          >
                            <EditOutlined className="mr-2" />
                            Edit Activity
                          </Button>
                          <Button
                            onClick={() => {
                              setProgress(true);
                              setPaid(false);

                              setId(1);
                            }}
                            style={{
                              backgroundColor: mainBackground,
                              borderRadius: "10px",
                              padding: "10px 20px",
                              color: "#fff",
                            }}
                            variant="contained"
                          >
                            <ChangeCircle className="mr-2" />
                            Change Status
                          </Button>

                          <Button
                            onClick={() => {
                              setProgress(false);
                              setId(activity.id);
                              setDeleteOpen(true);
                              setSuccess(1);
                            }}
                            style={{
                              backgroundColor: "#B10000",
                              borderRadius: "10px",
                              padding: "10px 20px",
                              color: "#fff",
                            }}
                            variant="contained"
                          >
                            <DeleteOutline className="mr-2" />
                            Delete Activity
                          </Button>
                        </>
                      )}
                    </div>
                  </div>
                </td>
              </tr>
            );
          }}
          url={
            loggedUser?.type === "PARTNER"
              ? `/api/activity/partner?projectId=${projectId}&partnerId=${loggedUser?.partnerId}&count=${count}`
              : `/api/activity/list?projectId=${projectId}&count=${count}`
          }
          title={"All Activities"}
        />
      </div>
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ProjectActivities);
